<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :onFetchData="onFetchData"
    :title="$t('model.role')"
    resource="roles"
    :onFormSubmit="onFormSubmit"
    :actionButtons="['new']"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsHash, columnsHash, formColumnsHash } from '../admin_configs/roles/columns';
import _ from 'lodash';

@Component
export default class Roles extends Vue {
  @Prop(String) type;

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      { prop: 'name_cont' }
    ].filter(Boolean).map(hash => _.merge(filterColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      { prop: 'id' },
      { prop: 'name' },
      { prop: 'created_at' },
      { prop: 'updated_at' }
    ].filter(Boolean).map(hash => _.merge(columnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data }) {
    const abilityI18n = _.get(data, 'ability_i18n', {});
    const customPermissions = _.get(data, 'custom_permissions', {});

    return [
      { prop: 'name' },
      {
        prop: 'custom_permissions',
        label: this.$t('role.customPermissions'),
        renderCell: {
          component: () => <bean-permissions rawData={customPermissions} createElement={h} abilityI18n={abilityI18n} />
        }
      }
    ].filter(Boolean).map(hash => _.merge(formColumnsHash[hash['prop']], hash))
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'roles.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'roles.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ resource, type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get(`/${resource}`, { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'new' || type === 'edit') {
      let permissionsData = await this.$request.get('/roles/permissions_attributes');
      let data;

      if (type === 'new') {
        data = permissionsData
      } else {
        data = await this.$request.get(`/${resource}/${this.$route.params.id}`);
        data.ability_i18n = permissionsData.ability_i18n

        _.each(permissionsData.permissions_attributes, (actions, modelName) => {
          _.each(permissionsData.permissions_attributes[modelName], (value, key) => {
            data.custom_permissions[modelName] = data.custom_permissions[modelName] || {}

            permissionsData.permissions_attributes[modelName][key] = data.custom_permissions[modelName][key] || false
          })
        })
      }

      data.custom_permissions = permissionsData.permissions_attributes

      return { data };
    }
  }

  async onFormSubmit({ data, resource, type }) {
    const body = data;

    const action = type === 'new' ? 'post' : 'put';
    const path = type === 'new' ? `/${resource}` : `/${resource}/${body.id}`;
    await this.$request[action](path, body);
    const message = type === 'new' ? this.$t('bean.createSuccess') : this.$t('bean.updateSuccess');
    this.$message.success(message);
    this.$router.push({ name: `${resource}.index` });
  }
}

export const route = [
  {
    path: '/roles',
    name: 'roles.index',
    component: Roles,
    props: {
      type: 'index',
    }
  },
  {
    path: '/roles/new',
    name: 'roles.new',
    component: Roles,
    props: {
      type: 'new',
    }
  },
  {
    path: '/roles/:id',
    name: 'roles.show',
    component: Roles,
    props: {
      type: 'show',
    }
  },
  {
    path: '/roles/:id/edit',
    name: 'roles.edit',
    component: Roles,
    props: {
      type: 'edit'
    }
  }
]
</script>
